import React from "react";
import { NavigationLinks } from "./NavigationLinks";

type NavigationHeaderMobileProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const NavigationHeaderMobile: React.FC<NavigationHeaderMobileProps> = ({
  isOpen,
  setIsOpen,
}) => {
  return (
    <>
      {/* Mobile hamburger */}
      <div className="md:hidden z-50">
        <button
          onClick={() => setIsOpen(true)}
          className="text-clear focus:outline-none"
          aria-label="Open menu"
        >
          {/* Hamburger icon */}
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Mobile fullscreen menu */}
      <div
        className={`fixed inset-0 z-50 bg-black transition-transform duration-300 ease-in-out
        ${isOpen ? "translate-x-0" : "translate-x-full"} 
        md:hidden flex flex-col items-center justify-center space-y-6`}
      >
        {/* Close button */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-4 right-4 text-white"
          aria-label="Close menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <NavigationLinks onClick={() => setIsOpen(false)} />
      </div>
    </>
  );
};
